// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80%;
  margin: 10px;
}

.login-form-container h4 {
  font-size: xx-large;
  margin: 0px;
  font-weight: normal;
}

.forgot-password-button {
  font-size: x-small;
  color: blue;
}

.login-button {
  margin-top: 10px;
  padding: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: rgba(184, 245, 235, 0.479);
  border-width: 1px;
  border-color: rgb(45, 74, 172);
  border-style: solid;
  border-radius: 5px;
  font-weight: bold;
}

.login-button:hover {
  opacity: .8;
}

.login-form-inputs-container {
  width: 100%;
}
.login-error-text-continer {
  font-size: small;
  color: brown;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Unauthed/Login/LoginPanel/LoginForm/LoginForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".login-form-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 80%;\n  margin: 10px;\n}\n\n.login-form-container h4 {\n  font-size: xx-large;\n  margin: 0px;\n  font-weight: normal;\n}\n\n.forgot-password-button {\n  font-size: x-small;\n  color: blue;\n}\n\n.login-button {\n  margin-top: 10px;\n  padding: 10px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  background-color: rgba(184, 245, 235, 0.479);\n  border-width: 1px;\n  border-color: rgb(45, 74, 172);\n  border-style: solid;\n  border-radius: 5px;\n  font-weight: bold;\n}\n\n.login-button:hover {\n  opacity: .8;\n}\n\n.login-form-inputs-container {\n  width: 100%;\n}\n.login-error-text-continer {\n  font-size: small;\n  color: brown;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
